import {useEffect, useState} from "react";
import {useSelector} from "react-redux";

import {IRPStore} from "../../app/rp_reducer";
import {budgetFilterDefaults} from "../../real_estate/constants/budget_filter_defaults";
import {useGetStatsQuery} from "../api/configurator_api";
import {fetchAllPropertiesCountBudget} from "../api/fetch_all_properties_count_budget";
import {getParams} from "../utils/get_property_api_params";
import {useRegionsIds} from "./use_regions_ids";

export const usePropertyConfiguratorBudgetValues = () => {
    const {regionsIds} = useRegionsIds();
    const areRegionsEmpty = !regionsIds || regionsIds.length === 0;
    const {data} = useGetStatsQuery({regionsIds: regionsIds || []}, {skip: areRegionsEmpty});
    const maxPrice = areRegionsEmpty ? undefined : data?.maxPrice;

    const formValues = useSelector((store: IRPStore) => store.propertyConfigurator.formValues);
    const [min, setMin] = useState<number | null>(null);
    const [range, setRange] = useState<number[] | null>(null);

    const getBudgetRange = async () => {
        const params = getParams(formValues, 1);
        const propertiesCountByBudget = await fetchAllPropertiesCountBudget(params);

        if (propertiesCountByBudget.length > 0) {
            setMin(propertiesCountByBudget[0]?.price_range.upper);
            setRange(propertiesCountByBudget.map(({property_count}) => property_count));
        } else {
            setMin(0);
            setRange([]);
        }
    };

    useEffect(() => {
        getBudgetRange();
    }, []);

    if (typeof min !== "number" || !Array.isArray(range)) {
        return null;
    }

    const step = 50000;
    const nearestMin = Math.ceil(min / step) * step;
    const max = maxPrice || nearestMin + range.length * step || budgetFilterDefaults.totalMax;

    return {
        max,
        min,
        step,
        range,
        nearestMin
    };
};
import {useEffect, useState} from "react";
import {useSelector} from "react-redux";

import {IRPStore} from "../../app/rp_reducer";
import {budgetFilterDefaults} from "../../real_estate/constants/budget_filter_defaults";
import {useGetStatsQuery} from "../api/configurator_api";
import {fetchAllPropertiesCountBudget} from "../api/fetch_all_properties_count_budget";
import {getParams} from "../utils/get_property_api_params";
import {useRegionsIds} from "./use_regions_ids";

export const usePropertyConfiguratorBudgetValues = () => {
    const {regionsIds} = useRegionsIds();
    const areRegionsEmpty = !regionsIds || regionsIds.length === 0;
    const {data} = useGetStatsQuery({regionsIds: regionsIds || []}, {skip: areRegionsEmpty});
    const maxPrice = areRegionsEmpty ? undefined : data?.maxPrice;

    const formValues = useSelector((store: IRPStore) => store.propertyConfigurator.formValues);
    const [min, setMin] = useState<number | null>(null);
    const [range, setRange] = useState<number[] | null>(null);

    const getBudgetRange = async () => {
        const params = getParams(formValues, 1);
        const propertiesCountByBudget = await fetchAllPropertiesCountBudget(params);

        if (propertiesCountByBudget.length > 0) {
            setMin(propertiesCountByBudget[0]?.price_range.upper);
            setRange(propertiesCountByBudget.map(({property_count}) => property_count));
        } else {
            setMin(0);
            setRange([]);
        }
    };

    useEffect(() => {
        getBudgetRange();
    }, []);

    if (typeof min !== "number" || !Array.isArray(range)) {
        return null;
    }

    const step = 50000;
    const nearestMin = Math.ceil(min / step) * step;
    const max = maxPrice || nearestMin + range.length * step || budgetFilterDefaults.totalMax;

    return {
        max,
        min,
        step,
        range,
        nearestMin
    };
};
